import React from 'react';
import classNames from 'classnames';
import Image from 'next/image';
import { useTheme } from 'next-themes';

import CardShapes from '@/icons/CardShapes';
import { toCapitalise } from '@/utils/toCapitalise';
import { ETheme } from '@/enums/theme';

import SectionTitle from '../SectionTitle/SectionTitle';
import LinkNumbers from '../LinkNumbers/LinkNumbers';
import TariffContent from './TariffContent/TariffContent';

import styles from './styles.module.scss';

const TariffCard = ({ item, onClick = () => null, className }) => {
  const theme = useTheme();

  return (
    <div
      className={classNames([
        styles.card,
        {
          [styles.black]: item?.black,
          [styles.hot]: item?.hot_icon,
          [styles.mascotSmall]: item?.mascot_position === 'top',
          [styles.mascotMiddle]: item?.mascot_position === 'middle',
          [styles.mascotBottom]: item?.mascot_position === 'bottom',
        },
        className,
      ])}
      itemScope
      itemType='https://schema.org/Offer'
    >
      {item?.hot_icon && (
        <div className={styles.hotIcon}>
          <Image
            src={item.hot_icon}
            alt='Hot tariff'
            title='Hot tariff'
            loading='lazy'
            layout='fill'
          />
        </div>
      )}
      {item?.mascot_icon && (
        <div className={styles.mascot}>
          <Image
            src={item.mascot_icon}
            alt='Mascot'
            title='Mascot'
            loading='lazy'
            layout='fill'
          />
        </div>
      )}
      {item?.corner_text && (
        <div className={styles.profitableCorner}>{item.corner_text}</div>
      )}
      {item?.ussd && (
        <div className={styles.backgroundWrapper}>
          <div className={styles.tag}>
            {item?.top_icon && (
              <Image
                src={
                  theme?.resolvedTheme === ETheme.DARK_MODE &&
                  item?.dark_mode_top_icon
                    ? item?.dark_mode_top_icon
                    : item?.top_icon
                }
                width={20}
                height={20}
                alt='tariff tag icon'
                title='tariff tag icon'
              />
            )}
            {toCapitalise(item?.type)}
          </div>
          <div className={styles.top}>
            <div className={styles.titleTop}>
              {item?.name && (
                <SectionTitle
                  titleModify={classNames(styles.title, 'title--large')}
                >
                  {item?.name}
                </SectionTitle>
              )}
              <div className={styles.rectangle}></div>
            </div>
            <div className={styles.priceContainer}>
              <span className={styles.price}>{item?.price} </span>
              <span className={styles.text}>₼/{item?.price_text}</span>
            </div>
            {!!item?.ussd && (
              <div className={styles.number}>
                <LinkNumbers numbers={item?.ussd} />
                {item?.text_after_ussd && (
                  <p className={styles.ussd_label}>{item.text_after_ussd}</p>
                )}
              </div>
            )}
          </div>
          <CardShapes />
        </div>
      )}
      <TariffContent item={item} theme={theme} onClick={onClick} />
    </div>
  );
};

export default TariffCard;
